__turbopack_context__.v({
  "icon-american-express": "checkout-payments-module-scss-module__I33jNG__icon-american-express",
  "icon-arrow": "checkout-payments-module-scss-module__I33jNG__icon-arrow",
  "icon-chat": "checkout-payments-module-scss-module__I33jNG__icon-chat",
  "icon-cross": "checkout-payments-module-scss-module__I33jNG__icon-cross",
  "icon-discover": "checkout-payments-module-scss-module__I33jNG__icon-discover",
  "icon-mastercard": "checkout-payments-module-scss-module__I33jNG__icon-mastercard",
  "icon-visa": "checkout-payments-module-scss-module__I33jNG__icon-visa",
  "location": "checkout-payments-module-scss-module__I33jNG__location",
  "paymentLogo": "checkout-payments-module-scss-module__I33jNG__paymentLogo",
  "phone": "checkout-payments-module-scss-module__I33jNG__phone",
  "radioActive": "checkout-payments-module-scss-module__I33jNG__radioActive",
  "radioButton": "checkout-payments-module-scss-module__I33jNG__radioButton",
  "radioLabel": "checkout-payments-module-scss-module__I33jNG__radioLabel",
  "radioLabelActive": "checkout-payments-module-scss-module__I33jNG__radioLabelActive",
  "radioLabelInactive": "checkout-payments-module-scss-module__I33jNG__radioLabelInactive",
  "radioSelectWrapper": "checkout-payments-module-scss-module__I33jNG__radioSelectWrapper",
  "radioSubLabel": "checkout-payments-module-scss-module__I33jNG__radioSubLabel",
  "radioWrapper": "checkout-payments-module-scss-module__I33jNG__radioWrapper",
  "trade-mark": "checkout-payments-module-scss-module__I33jNG__trade-mark",
});
